export const HAULER_PROFILE_DIVISION_COOKIE = 'haulerProfileDivisionId';
export const HAULER_PROFILE_DIVISION_COOKIE_EXPIRATION = 365;
